import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
// import Paper from '../../UiComponents/Paper';
import { Link } from 'react-router-dom';
// import ReplyAll from './replyAll';
import CloseButton from '../../UiComponents/CloseButton';
import ActorsHandler from './actorsHandler';
import styles from './compose.module.scss';
import MessageHandler from './messageHandler';
import getLabel from './../../../utils/labels'
import Confirmation from './../../commonComponents/confirmationBox';
import sortBy from 'lodash/sortBy';

class ComposeMail extends Component {
    constructor(props) {
        super(props);
        let draftData = this.getDraft(props.lastMail)

        let to = [props.lastMail.from], cc = [], rol = props.lastMail.replyMailOptions.rol;
        if (draftData) {
            to = draftData.to;
            cc = draftData.cc;

            rol = rol.map(messageOptions => {
                let tempMessageOptions = messageOptions;
                let selectedOptions = draftData.body.find(item => item && item.messageGroupId === messageOptions.id)

                if (selectedOptions) {
                    if (tempMessageOptions.type === "mcq") {
                        if (selectedOptions.optionId) {
                            tempMessageOptions = { ...messageOptions, selectedOptions: [selectedOptions.optionId] };
                        } else {
                            tempMessageOptions = { ...messageOptions, selectedOptions: null };
                        }
                    } else if (tempMessageOptions.type === "multiple") {
                        tempMessageOptions = { ...messageOptions, selectedOptions: selectedOptions.options };
                    }
                }
                return tempMessageOptions
            });
        }

        if (props.match.params.composeType === 'replyall') {
            to = [...props.lastMail.to, ...to];
        }

        to = to.filter(item => item !== props.selfActor);

        this.state = {
            rol,       //reponse option list
            pretext: {},
            postText: {},
            body: [],
            to,
            cc,
            from: null,
            isConfirmationOpen: false,
            isErrorBoxOpen: false
        };
    }

    onActorsSelction = () => { }

    clearActorSelection = () => { }

    saveToActors = (selectedActors) => {
        this.setState({
            to: selectedActors
        }, () => this.saveDraftData())
    }

    saveCcActors = (selectedActors) => {
        this.setState({
            cc: selectedActors
        }, () => this.saveDraftData())
    }

    getActorsList = (type) => {
        let selectedActors = [];
        if (type === 'to') {
            selectedActors = this.state.to
        } else {
            selectedActors = this.state.cc
        }
        return <ActorsHandler
            orgChart={this.props.orgChart}
            selfActor={this.props.selfActor}
            actors={this.props.actors}
            type={type}
            isFirstMail={this.props.isFirstMail}
            saveToActors={this.saveToActors}
            saveCcActors={this.saveCcActors}
            selectedActors={selectedActors}
            //only for tutorial - niot needed in mail therad part
            tutorial={this.props.tutorial}
            startTutorial={this.props.startTutorial}
            stopTutorial={this.props.stopTutorial}
            addStepsToTutorial={this.props.addStepsToTutorial}
            updateStepNumber={this.props.updateStepNumber}
        />
    }

    getToActorsForGreetings = () => {
        const { actors } = this.props;
        let { to, cc } = this.state;
        let temp, actorArray = [];
        to = [...to, ...cc];

        if (to) {
            let actorDetails = to.map((toActor) => {
                temp = actors.clients.find(actor => actor.id === toActor) || actors.inActors.find(actor => actor.id === toActor)

                if (cc.includes(toActor)) {
                    return { type: 'cc', details: temp }
                } else {
                    return { type: 'to', details: temp }
                }
            })
            return actorDetails
        }
    }

    getFirstNamesOfActors = () => {
        let array = this.getToActorsForGreetings();
        let actorNames = []
        if (array.length >= 2) {
            return getLabel('label_all_text')
        } else {
            array.map(item => {
                if (item.details.is_group_email === 0) {
                    actorNames.push(item.details.first_name)
                } else {
                    actorNames.push(getLabel('label_all_text'))
                }
            })
            return actorNames.join(", ");
        }
    }

    getGreetingText = () => {
        return <div className={styles.salutaion}>Hi {this.getFirstNamesOfActors()},</div>
    };

    getPreText = (replyMailOptions) => {
        if (replyMailOptions.preText) {
            return replyMailOptions.preText.map((para, key) => <div className={styles.salutaion} key={key} dangerouslySetInnerHTML={{ __html: para }} />)
        }
    };

    getPostText = (replyMailOptions) => {
        if (replyMailOptions.postText) {
            return replyMailOptions.postText.map((para, key) => <div className={styles.thanks} key={key} dangerouslySetInnerHTML={{ __html: para }} />)
        }
    };

    getSelfActor = () => {
        const { selfActor, actors } = this.props;

        let actorDetails = actors.clients.find(actor => actor.id === selfActor) || actors.inActors.find(actor => actor.id === selfActor);
        if (actorDetails) {
            return actorDetails
        }
        return selfActor;
    }

    getEmailSignature = () => {
        const selfActor = this.getSelfActor();
        return (
            <div
                style={{
                    margin: '10px 0',
                    lineHeight: '22px'
                }}
            >
                {getLabel('label_regards')},<br />{selfActor.first_name} {selfActor.last_name}<br />{selfActor.role}<br />{selfActor.company}
            </div>
        )
    }

    updateBody = (id, selectedOptions) => {
        this.setState({
            rol: this.state.rol.map((messageGroup) => {
                if (messageGroup.id === id) {
                    return { ...messageGroup, selectedOptions: selectedOptions };
                }
                return messageGroup;
            })
        }, () => this.saveDraftData());
    }

    clearBody = (id) => {
        this.setState({
            rol: this.state.rol.map((messageGroup) => {
                if (messageGroup.id === id) {
                    return { ...messageGroup, selectedOptions: null };
                }
                return messageGroup;
            })
        }, () => this.saveDraftData(true));
    }

    saveDraftData = (clearData) => {
        const { match, lastMail } = this.props;
        const { rol, to, cc } = this.state;

        let messageOptionsList = rol.map(optionGroup => {
            if (optionGroup.type === "mcq" && optionGroup.selectedOptions) {
                if (!clearData) {
                    return {
                        messageGroupId: optionGroup.id,
                        optionId: optionGroup.selectedOptions[0],
                        type: optionGroup.type
                    }
                } else {
                    return {
                        messageGroupId: optionGroup.id,
                        optionId: null,
                        type: optionGroup.type
                    }
                }
            } else if (optionGroup.type === "multiple" && optionGroup.selectedOptions) {
                return {
                    messageGroupId: optionGroup.id,
                    selectedOptions: optionGroup.selectedOptions,
                    type: optionGroup.type
                }
            }
        });

        let postMailData = {
            primaryMailId: lastMail.id,
            responseMailId: lastMail.replyMailOptions.id,
            actionTakenAt: 5,
            cc: cc,
            to: to,
            messageOptionsList: messageOptionsList
        };
        this.props.saveDraft(postMailData);
    }

    sendData = () => {
        const { match, lastMail } = this.props;
        const { rol, to, cc } = this.state;

        let messageOptionsList = rol.map(optionGroup => {
            if (optionGroup.type === "mcq") {
                return {
                    messageGroupId: optionGroup.id,
                    optionId: optionGroup.selectedOptions[0],
                    type: optionGroup.type
                }
            } else {
                return {
                    messageGroupId: optionGroup.id,
                    choosenOptions: optionGroup.selectedOptions,
                    type: optionGroup.type
                }
            }
        });

        let timeData = this.props.getTimeData();

        let postMailData = {
            primaryMailId: lastMail.id,
            responseMailId: lastMail.replyMailOptions.id,
            actionTakenAt: timeData.timeLeft,
            cc: cc,
            to: to,
            messageOptionsList: messageOptionsList
        };
        this.props.postData(postMailData);
        window.location.href = '#' + match.url.replace(`/${match.params.composeType}`, '')
    }

    getDraft = (mail) => {
        return mail.actionThread && mail.actionThread.find((action) => action.type === "draft")
    }

    getMessageBoxList = (rol) => {
        const sortedlist = sortBy(rol, ['id']);
        return sortedlist.map((messageOptions, key) => {
            return (<MessageHandler
                {...messageOptions}
                isFirstMail={this.props.isFirstMail}
                key={key}
                updateBody={this.updateBody}
                clearBody={this.clearBody}
                //only for tutorial - niot needed in mail therad part
                tutorial={this.props.tutorial}
                startTutorial={this.props.startTutorial}
                stopTutorial={this.props.stopTutorial}
                addStepsToTutorial={this.props.addStepsToTutorial}
                updateStepNumber={this.props.updateStepNumber}
            />);
        });
    }

    getToActors = () => {
        let { from, to, actors } = this.props;
        let temp, actorArray = [];
        to = [...to, from];
        to = to.filter(item => item !== this.props.selfActor);
        if (to) {
            let actorDetails = to.map((toActor) => {
                temp = actors.clients.find(actor => actor.id === toActor) || actors.inActors.find(actor => actor.id === toActor)

                if (temp) {
                    actorArray.push(temp.first_name + ' ' + temp.last_name)
                } else {
                    return actorArray.push(toActor);
                }
            })

            return actorArray.join(", ");
        }
    }

    getSelfActor = () => {
        const { actors } = this.props;
        return actors.inActors.find(actor => actor.id === this.props.selfActor)
    }

    checkIfAllAttributesArePresent = () => {
        const { rol, to } = this.state;
        let draftData = this.getDraft(this.props.lastMail);
        let returnValue = true;
        let messageOptionsList = rol.map(optionGroup => {
            if (draftData && draftData.body) {
                return draftData.body.find(item => item && item.messageGroupId === optionGroup.id);
            }
            return optionGroup.selectedOptions
        });

        let undefinedPresent = messageOptionsList.indexOf(undefined)
        let falsePresent = messageOptionsList.indexOf(false)

        if (undefinedPresent > -1 || falsePresent > -1) {
            returnValue = false
        }

        return returnValue && to.length > 0
    }

    goToNextTutorialStep = () => {
        this.props.updateStepNumber(this.props.tutorial.stepIndex + 1);
    }

    openConfirmationBox = () => {
        if (this.props.tutorial.isRunning) {
            this.sendData();
            this.props.stopTutorial();
            setTimeout(() => {
                // this.props.startCall({
                //     primaryMailId: 10014
                // })
                this.goToNextTutorialStep();
                this.props.startTutorial();
            }, 2000);
        } else {
            if (this.checkIfAllAttributesArePresent()) {
                this.setState({
                    isErrorBoxOpen: false,
                    isConfirmationOpen: true
                })
            } else {
                this.setState({
                    isErrorBoxOpen: true
                })
            }
        }
    }

    closeConfirmationBox = () => {
        this.setState({
            isConfirmationOpen: false
        })
    }

    closeErrorBox = () => {
        this.setState({
            isErrorBoxOpen: false
        })
    }

    render() {
        const { match, isFirstMail } = this.props;
        const { rol, isConfirmationOpen, isErrorBoxOpen } = this.state;
        const mailHeight = {
            minHeight: this.props.parentHeight - 20
        };

        let selfActor = this.getSelfActor();
        return (
            <Fragment>
                <div className={styles.container} style={{ minHeight: mailHeight.minHeight }}>
                    <div className={styles['icon-container']}>
                        <img src={selfActor.gravatar} className={styles.image} />
                    </div>
                    <div className={styles['content']}>
                        <header className={styles['header']}>
                            <div className={styles["people-container"]} >
                                <div className={styles['from']} >
                                    {`${selfActor.first_name} ${selfActor.last_name}`}
                                </div>
                            </div>
                        </header>
                        <div className={styles.body}>
                            <div className={styles.to}>
                                <p style={{ marginRight: '20px' }}>{getLabel('label_to_actors_list')}</p>
                                {this.getActorsList('to')}
                            </div>
                            <div className={styles.to}>
                                <p style={{ marginRight: '20px' }}>Cc:</p>
                                {this.getActorsList('cc')}
                            </div>
                            <div
                                className={styles['message-body']}
                                style={(!this.props.match.url.includes("tutorial")) ?
                                    { minHeight: mailHeight.minHeight * 0.5 }
                                    :
                                    { minHeight: mailHeight.minHeight }
                                }>
                                <div className={styles['pre-text']}>{this.getGreetingText()}</div>
                                {/* <div className={styles['pre-text']}>{this.getPreText(this.props.lastMail.replyMailOptions)}</div> */}
                                {this.getMessageBoxList(rol)}
                                {/* <div className={styles['post-text']}>{this.getPostText(this.props.lastMail.replyMailOptions)}</div> */}
                                {this.getEmailSignature()}
                            </div>
                            <div className={styles['action-buttons']}>
                                <Link to={match.url.replace(`/${match.params.composeType}`, '')} className={styles['cancel-button']}>
                                    {getLabel('label_cancel_button')}
                                </Link>
                                <div
                                    className={styles['send-button']}
                                    onClick={this.openConfirmationBox}
                                    id="tutorial-send-email"
                                >
                                    {getLabel('label_send_button')}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <CloseButton isLink to={match.url.replace(`/${match.params.composeType}`, '')} />
            <button className={styles['send-button']} onClick={this.sendData} >Send</button> */}
                </div >
                {
                    isConfirmationOpen ?
                        < Confirmation
                            acceptButtonText={getLabel('label_send_button')}
                            confimationMessage={getLabel('label_send_mail_confirmation')}
                            onAcceptClick={this.sendData}
                            onCancelClick={this.closeConfirmationBox}
                        />
                        : null
                }
                {
                    isErrorBoxOpen ?
                        < Confirmation
                            confimationMessage={getLabel('label_mail_error_message')}
                            onCancelClick={this.closeErrorBox}
                            isErrorBox={true}
                        />
                        : null
                }
            </Fragment>

        );
    }
}

ComposeMail.propTypes = {
    lastMail: PropTypes.object,
    match: PropTypes.object,
    postData: PropTypes.func,

};

export default ComposeMail;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/Compose.js